import React from 'react';
import PropTypes from "prop-types";

class ProcessingOverlayComponent extends React.Component {
    constructor(props){
        super(props);
    }

    render(){
        const {show=false, fullscreen=true, message="Processing..."} = this.props;
        if (show){
            const loaderOverlayStyling = fullscreen ? "loader-overlay loader-fullscreen" : "loader-overlay";
            return (
                <div className={loaderOverlayStyling}>
                    <div className="loader-wrapper">
                        <div className="loader"></div>
                        <p>{message}</p>
                    </div>
                </div>
            );
        } else {
            return "";
        }
    }
}

ProcessingOverlayComponent.propType = {
    show: PropTypes.bool.isRequired,
    fullscreen: PropTypes.bool,
    message: PropTypes.object
};

export default ProcessingOverlayComponent;